module.exports = __webpack_public_path__ + "static/media/workout-empty.0a756ae5.svg";